import { useTracker, type VirtPathInput } from '@lichtblick/tracker';
import { useCallback } from 'react';

type Callback = (page: { path: string; title: string }) => VirtPathInput;

const PageArea = {
  Heating: 'form-process',
  Other: 'form-process',
  Commodity: 'form-process',
  ServiceView: 'service-view',
} as const;

export type EnergyType = 'Strom Gas' | 'Gas' | 'Strom';

export const useTrackVirtPathAndPageMetaWithEnergy = (energyType: EnergyType) => {
  const { trackPageMetaEvent, trackVirtPathEvent } = useTracker();

  const trackVirtPathAndPageMetaWithEnergy = useCallback(
    (pageArea: keyof typeof PageArea, callback: Callback) => {
      trackVirtPathEvent(
        callback({
          title: energyType,
          path: energyType.replace(' ', '-').toLowerCase(),
        }),
      );
      trackPageMetaEvent({
        pageArea: pageArea,
        pageType: PageArea[pageArea],
      });
    },
    [energyType, trackPageMetaEvent, trackVirtPathEvent],
  );

  return trackVirtPathAndPageMetaWithEnergy;
};

export const useTrackVirtPathAndPageMeta = () => {
  const { trackPageMetaEvent, trackVirtPathEvent } = useTracker();

  const trackVirtPathAndPageMeta = useCallback(
    (virtPagePath: string, virtPageTitle: string, pageArea: keyof typeof PageArea) => {
      trackVirtPathEvent({
        virtPagePath,
        virtPageTitle,
      });
      trackPageMetaEvent({
        pageArea,
        pageType: PageArea[pageArea],
      });
    },
    [trackPageMetaEvent, trackVirtPathEvent],
  );

  return trackVirtPathAndPageMeta;
};
